module.exports = __webpack_public_path__ + "img/12.9189e189.png";